// AUTO-GENERATED FILE. DO NOT EDIT.
// Source: config/specs/asyncapi.yaml (info.version: 1.0.0)
// This is the protocol version, independent of SDK implementation version

// Protocol version from AsyncAPI spec
export const SPEC_VERSION = "1.0.0";

// Schema ref is derived from protocol major version
const SPEC_MAJOR = SPEC_VERSION.split('.')[0];
export const SCHEMA_REF = `optave.message.v${SPEC_MAJOR}`;
